import ComponentHeaderSchevron from "./HeaderSchevron";
import CounterInline from "./components/CounterInline/HeaderSchevronCounterInline";
import Subtitle from "./components/Subtitle/HeaderSchevronSubtitle";
import Title from "./components/Title/HeaderSchevronTitle";

export interface IHeaderSchevronExtensions {
    Title: typeof Title;
    CounterInline: typeof CounterInline;
    Subtitle: typeof Subtitle;
}

export const HeaderSchevron: typeof ComponentHeaderSchevron &
    IHeaderSchevronExtensions = Object.assign(ComponentHeaderSchevron, {
    Title,
    CounterInline,
    Subtitle,
});

export type { HeaderSchevronProps } from "./types";
